var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVirtualsporticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_14_11",
    "data-name": "Component 14 \\u2013 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.4,
    height: 55.512,
    viewBox: "0 0 48.4 55.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M3315.353,227.126l-13.792-7.456-12.824,33.717-5.151-1.93,6.929-18.439c-.586-.184-1.083-.309-1.555-.5-.719-.284-1.082-.026-1.378.659-.974,2.253-2,4.48-3.048,6.794l-4.939-2.223,7.941-18.969c-2.268.853-3.212,2.107-6.65,8.69-.8-.353-1.609-.706-2.415-1.072s-1.634-.759-2.544-1.182c2.527-6.356,6.135-11.527,13.211-13.145a11.359,11.359,0,0,1,4.505-.126c4.494.845,8.973,1.788,13.022,4.127,3.331,1.924,6.749,3.7,10.126,5.538.373.2.736.429,1.179.689C3317.1,223.9,3316.267,225.443,3315.353,227.126Z",
    transform: "translate(-3269.572 -199.72)",
    fill: "#b48c2e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M3342.142,176.511a5.54,5.54,0,0,1-5.455-5.595,5.6,5.6,0,0,1,5.554-5.519,5.676,5.676,0,0,1,5.553,5.558A5.609,5.609,0,0,1,3342.142,176.511Z",
    transform: "translate(-3314.535 -165.397)",
    fill: "#b48c2e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M3262.493,341.676a5.5,5.5,0,1,1-5.523-5.489A5.517,5.517,0,0,1,3262.493,341.676Z",
    transform: "translate(-3251.484 -291.782)",
    fill: "#b48c2e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualsporticon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/virtual.sport.icon.6602fbe1b79deb359ca7a026e9fdcb78.svg";
export { ForwardRef as ReactComponent };